// auth.js
export const LOGOUT = 'LOGOUT'
export const SAVE_TOKEN = 'SAVE_TOKEN'
export const FETCH_USER = 'FETCH_USER'
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS'
export const FETCH_USER_FAILURE = 'FETCH_USER_FAILURE'
export const UPDATE_USER = 'UPDATE_USER'
export const UPDATE_COMPANY = 'UPDATE_COMPANY'

// lang.js
export const SET_LOCALE = 'SET_LOCALE'

// sidebar.js
export const SET_SIDEBAR = 'SET_SIDEBAR'
export const SET_SIDEBAR_CATEGORIES = 'SET_SIDEBAR_CATEGORIES'
export const SET_SIDEBAR_COMPANIES = 'SET_SIDEBAR_COMPANIES'
export const SET_SIDEBAR_PROJECTS = 'SET_SIDEBAR_PROJECTS'
export const SET_SIDEBAR_PRINTABLETYPES = 'SET_SIDEBAR_PRINTABLETYPES'
export const SET_SIDEBAR_MY_AUDITS = 'SET_SIDEBAR_MY_AUDITS'
export const CLEAR_SIDEBAR = 'CLEAR_SIDEBAR'
export const SET_EXPANDED = 'SET_EXPANDED'

// router.js
export const SET_LASTROUTE = 'SET_LASTROUTE'


// WEBPACK FOOTER //
// ./resources/assets/js/store/mutation-types.js